import CardSystem, { getCardHandler } from '../CardSystem';
import TransformComponent from 'Component/Transform';
import { StartAnimation } from '../../Animation/AnimationHelper';
import { AnimationSystemEvent } from '../../Animation/AnimationSystem';
import CardStateHelper from 'State/Card/CardStateHelper';
import CardAnimationTask from 'Utility/Task/CardAnimationTask';
import { CARD_STACK_OFFSET } from "Constants/InGame";
import { ICardStateTaskData } from "State/Card/ICardState";
import StreakBar from 'Prototype/UI/Level/StreakBar';
import { LevelHud } from 'System/UI/HUD/LevelHud';

export default function FoldCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    StreakBar.instance.update();

    if (taskData.alreadyFolded) {
        return;
    }

    system.cardStack.update();
    const card = system.getCardByID(taskData.cards[0]);

    // Re-add to the stack to make sure it's in front.
    system.stackContainer.addChild(card);

    getCardHandler(card).setCardFaceUp(false);
    card.getComponent(TransformComponent).position.x = CARD_STACK_OFFSET;

    // Stop any animations (prevent weird scale issues with "Pulse").
    card.scene.emit(AnimationSystemEvent.STOP, card);

    const task = new CardAnimationTask(
        taskData,
        system,
        'CardFold',
        card,
        null,
        true
    );

    const matches = CardStateHelper.getCardMatches(
        system.store.getPreviousState().levelState.cardsState
    );

    if (matches.length > 0) {
        StartAnimation(system.getCardByID(matches[0]), 'Pulse');
        StartAnimation((LevelHud.instance.getLayout() as any).undoButton, 'Pulse', { delay: 400 });
    }

    if (taskData.queueNext) {
        system.taskQueue.queueNext(task);
    } else {
        system.taskQueue.queue(task);
    }
}
